import { useEffect } from "react";
import { NumberParam, useQueryParam, withDefault } from "use-query-params";

import { PAGE_SIZE_OPTIONS } from "common/constants";

export default function usePageSize(localstorageId: string) {
  const pageSizeKey = `table-${localstorageId}/pageSize`;

  // Get default page size from localStorage or fallback to PAGE_SIZE_OPTIONS
  const getStoredPageSize = () => {
    const storedPageSize = localStorage.getItem(pageSizeKey);

    if (storedPageSize) {
      const parsedPageSize = Number(storedPageSize);

      // Validate that the stored value is in PAGE_SIZE_OPTIONS
      if (PAGE_SIZE_OPTIONS.includes(parsedPageSize)) {
        return parsedPageSize;
      }
    }

    return PAGE_SIZE_OPTIONS[1];
  };

  const [pageSize, setPageSize] = useQueryParam(
    "pageSize",
    withDefault(NumberParam, getStoredPageSize()),
    {
      removeDefaultsFromUrl: true,
      updateType: "replaceIn",
    },
  );

  // Clamp to a valid option synchronously so the component never renders with
  // an out-of-bounds value from the URL (e.g. ?pageSize=99999) before the
  // effect below corrects it.
  const safePageSize = PAGE_SIZE_OPTIONS.includes(pageSize)
    ? pageSize
    : getStoredPageSize();

  useEffect(() => {
    if (!PAGE_SIZE_OPTIONS.includes(pageSize)) {
      setPageSize(getStoredPageSize());
    }
  }, [pageSize]);

  function onPageSizeChange(newPageSize: number) {
    setPageSize(newPageSize);
    // Store the new page size in localStorage
    localStorage.setItem(pageSizeKey, newPageSize.toString());
  }

  return { pageSize: safePageSize, onPageSizeChange };
}
